export const reportsI18n = {
  reports: {
    selector: {
      all: 'All',
      noFilter: 'No Filter',
    },
    type: {
      PYRAMID: 'Pyramid report',
      MEETING: 'Meeting report',
      DETAILED: 'Detailed report',
      TARGET: 'Target report',
    },
    header: {
      meetingReports: 'Meeting Reports',
      bigReports: 'Big Reports',
      pyramidsReports: 'Pyramids Reports',
      targetReports: 'Target Reports',
      rankingReports: 'Ranking Reports',
    },
    filterHeader: {
      filterHeading: 'Filter',
      reportsHeading: 'Targets Report',
      generateReport: 'Generate Report',
      tags: {
        companyName: 'Company',
        country: 'Country',
        fromDate: 'From',
        toDate: 'To',
      },
    },
    filterModal: {
      title: 'Reports table filter',
      company: {
        header: 'Company',
        placeholder: 'Select company',
      },
      country: {
        header: 'Country',
        placeholder: 'Select country',
      },
      date: {
        header: 'Date created',
        fromDatePlaceholder: 'From date',
        toDatePlaceholder: 'To date',
      },
      errors: {
        invalidDates: "Selected 'From Date' is before selected 'End Date'",
      },
    },
    generationModal: {
      title: 'Generate target report',
      network: {
        header: 'Network',
        placeholder: 'Select Network',
      },
      company: {
        header: 'Company',
        placeholder: 'Select company',
      },
      country: {
        header: 'Country',
        placeholder: 'Select country',
      },
      errors: {
        network: 'Network is required',
        company: 'Company is required',
        country: 'Country is required',
      },
      footer: {
        confirm: 'Generate',
      },
    },
    table: {
      meetingReportBetaVersionDisclaimer:
        'The new <0>Meeting Report</0> replaces the previous <0>Small Report</0>. This feature is currently released as a beta version and may be subject to further changes, optimizations, or improvements in future releases.',
      filename: 'File name',
      company: 'Company',
      year: 'Ranking Year',
      type: 'Type',
      country: 'Country',
      size: 'Size',
      format: 'Format',
      date: 'Date',
      actions: 'Actions',
      empty: 'No data',
      filteredEmpty: 'No result available for given filter',
      downloadTooltip: 'Download report',
      processingTooltip: 'The report is being processed',
      errorTooltip: `There was an error and the report couldn't be generated`,
      rankingGenerationErrorTooltip: 'Click to generate the failed report again.',
      rankingGenerationInProgressTooltip: 'Another report is already being generated.',
    },
    rankingInfoBox: {
      download: 'Download Reports',
      downloadDescription: 'Click to download all the reports you have selected from the table.',
      downloadErrorMessage: 'An error occurred while downloading the selected reports.',
      downloadConfirmHeading: 'Confirm ZIP Creation',
      downloadConfirmMessage:
        'The requested operation will generate a ZIP file containing the selected reports. Once the process is complete, you will receive an email with a download link. This link will allow you to access and download the file directly. Please note that the link will be valid for a limited period, so make sure to download the file promptly.',
      selectOneOrMoreReports: 'Please select at least two reports to proceed with the download.',
      reportsCounter: 'Reports Counter',
      filters: 'Reports Filters',
      company: 'Company',
      year: 'Ranking Year',
      selectCompany: 'Select Company',
      selectYear: 'Select Year',
      notifications: {
        success: {
          title: 'Success',
          description: 'ZIP successfully created. An email has been sent.',
        },
      },
    },
  },
}
